import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);
export default {
    prePayorder(data) {
        return axios.request({
            url: "pay/prepayorder",
            method: "post",
            data
        });
    },
    payOrder(data) {
        return axios.request({
            url: "pay/payorder",
            method: "post",
            data
        });
    },
    payCodeOrder(data) {
        return axios.request({
            url: "pay/paycodeorder",
            method: "post",
            data
        });
    },
    orderDetail(data) {
        return axios.request({
            url: "user/orderdetail",
            method: "post",
            data
        });
    }
}
